import { render, staticRenderFns } from "./LinkedClaimRow.vue?vue&type=template&id=ce4eb13e&scoped=true"
import script from "./LinkedClaimRow.vue?vue&type=script&lang=ts"
export * from "./LinkedClaimRow.vue?vue&type=script&lang=ts"
import style0 from "./LinkedClaimRow.vue?vue&type=style&index=0&id=ce4eb13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4eb13e",
  null
  
)

export default component.exports